import { render, staticRenderFns } from "./insureInfo.vue?vue&type=template&id=5a060929&scoped=true"
import script from "./insureInfo.vue?vue&type=script&lang=js"
export * from "./insureInfo.vue?vue&type=script&lang=js"
import style0 from "./insureInfo.vue?vue&type=style&index=0&id=5a060929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a060929",
  null
  
)

export default component.exports